// 充值相关
import service from "@/service/request.js";

//获取算力充值类型
export const GetComputingPowerVipType = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/member/api/v2/MemberOrder/GetComputingPowerVipType",
  method: "post",
  data
});

//获取套餐列表
export const GetDosingPackageList = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/member/api/v2/Package/GetDosingPackageList",
  method: "post",
  data
});

//设计师消息推送
export const SendRechargeAIMsg = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/member/api/v2/Message/SendRechargeAIMsg",
  method: "post",
  data
});

// 获取支付二维码
export const GetMemberQRCode = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/iyw-wallet/api/Pay/GetMemberQRCode",
  method: "post",
  data
});

// 获取支付状态
export const PayPCOrderQuery = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/iyw-wallet/api/Pay/PayPCOrderQuery",
  method: "post",
  data
});

// 获取支付状态
export const GetUserVipInfo = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/member/api/v2/MemberAuth/GetMemberAuthInfo",
  method: "post",
  data
});
